import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 rounded-2xl overflow-hidden">
          <div className="relative min-h-[320px] md:min-h-[420px] bg-amber-100/50">
            <img
              src="https://readdy.ai/api/search-image?query=Dramatic%20journalism%20concept%20with%20warm%20atmospheric%20lighting%2C%20typewriter%20and%20papers%20on%20dark%20desk%2C%20editorial%20photography%2C%20golden%20amber%20and%20deep%20brown%20tones%2C%20investigative%20mood%2C%20professional%20composition%2C%20mysterious%20newsroom%20atmosphere&width=800&height=600&seq=cta-bg-01&orientation=landscape"
              alt="黑料在线 - 爆料投稿"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute top-4 left-4">
              <span className="text-xs font-medium text-background-50 bg-foreground-900/60 px-3 py-1 rounded-full">
                你有料，我来爆
              </span>
            </div>
            <div className="absolute bottom-6 left-6">
              <h3 className="text-2xl md:text-4xl font-black font-heading text-background-50 leading-tight">
                全民
                <br />
                爆料
                <br />
                时代
              </h3>
            </div>
          </div>

          <div className="bg-background-50 flex flex-col items-center justify-center text-center p-8 md:p-12">
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-4">
              你有猛料？
              <br />
              我们帮你曝光
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-8 leading-relaxed max-w-md">
              如果你掌握网红、明星、主播的真实爆料信息，欢迎向我们投稿。我们拥有专业的采编团队，确保每一条爆料都得到真实、客观的报道。你的身份将受到严格保护。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 whitespace-nowrap px-7 py-3 bg-accent-500 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-accent-600 transition-colors cursor-pointer"
            >
              了解投稿方式
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}